import React, { useState, useMemo } from 'react';
import { Phone, MessageSquare } from 'lucide-react';
import { getSiteName } from '../api/axios';
import { toast } from 'react-hot-toast';
import { SubmitEnquiry } from '../features/ticket/ticketSlice';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import useDocumentTitle from '../hooks/useDocumentTitle';
import { getdomainName } from '../api/axios';
import CityAutosuggest from './CityAutosuggest';
const Enquiry = () => {
  const location = useLocation();

  const Data = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      PlanType: '3',
      title: "Mr",
      fname: "",
      lname: "",
      email: "",
      mobile: "",
      TravelDate: "",
      FromCity: params.get("city") || "",
      adult: "",
      remarks: "Hello! Can i get more info on this?",
      countrycode: "91",
      leadsource: "12",
      Defaultb2b: 0,
      consent: true
    };
  }, [location.search]);

  useDocumentTitle('Enquiry');
  const dispatch = useDispatch();
  const [form, setForm] = useState(Data);
  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const onSelect = (city) => {
    setForm(prev => ({
      ...prev,
      FromCity: city.cityName,
    }));
  };

  const [loading, setLoading] = useState(false);
  const [Success, setSuccess] = useState(false);
  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
  };
  const submit = async (e) => {
    e.preventDefault();
    // 1. Required Fields Validation
    if (!form.fname.trim()) {
      return toast.error('First Name is required', { autoClose: 2000 });
    }
    if (!form.lname.trim()) {
      return toast.error('Last Name is required', { autoClose: 2000 });
    }
    if (!form.mobile.trim()) {
      return toast.error('Please enter a valid Mobile number', { autoClose: 2000 });
    }

    // 2. Email Validation
    if (!form.email.trim()) {
      return toast.error('Email is required', { autoClose: 2000 });
    } else if (!validateEmail(form.email)) {
      return toast.error('Invalid Email format', { autoClose: 2000 });
    }

    if (!form.TravelDate) {
      return toast.error('Please select a Travel Date', { autoClose: 2000 });
    }

    // From City Validation
    if (!form.FromCity.trim()) {
      return toast.error('Destination city (From City) is required', { autoClose: 2000 });
    }

    // Adult Count Validation (Must be at least 1)
    const adultCount = parseInt(form.adult);
    if (!form.adult || isNaN(adultCount) || adultCount < 1) {
      return toast.error('At least 1 adult is required', { autoClose: 2000 });
    }
    // 3. Consent Validation
    if (!form.consent) {
      return toast.error('Please authorize us to contact you', { autoClose: 2000 });
    }

    setLoading(true);

    try {
      const response = await dispatch(
        SubmitEnquiry(form)
      ).unwrap();
      const { data } = response;
      if (data.status.success) {
        window.location.href = "/thankyou";
        setSuccess(true)
      } else {
        setLoading(false);
      }


    } catch (err) {
      console.log(err);
      toast.error(err.message, { autoClose: 2000 });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 sm:p-8"
      style={{ backgroundImage: 'radial-gradient(#e5e7eb 1px, transparent 1px)', backgroundSize: '20px 20px' }}>

      <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg p-6 sm:p-10 border border-gray-100">

        {/* Header Section */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-serif text-[#089bda] mb-3 font-semibold">
            Begin Your Journey
          </h1>
          {/* <p className="text-gray-500 text-sm leading-relaxed max-w-xs mx-auto">
            Work Space No. -56, Dsidc Complex, Mata Sundri Road, Delhi, New Delhi, Delhi, 110002.
          </p> */}
        </div>

        {/* Contact Bar */}
        <div className="bg-gray-50 rounded-lg py-2 px-4 flex flex-wrap justify-center gap-4 mb-8 border border-gray-100">
          <div className="flex items-center gap-2 text-[10px] sm:text-xs font-bold text-gray-700">
            <Phone size={14} className="text-pink-600 fill-pink-600" />
            <span>CALL US AT : +91 94038 91941</span>
          </div>
          <div className="flex items-center text-[10px] sm:text-xs font-bold text-gray-700">
            <a className='flex' href={`https://wa.me/+919403891941?text=Hi %0a%0a I visited  ${getSiteName()} . I am interested in this offer. Do contact me to discuss it further.Thanks.`} target="_blank">
              <div className="text-green-500">
                <img style={{ height: '20px' }} src="https://img.icons8.com/?size=100&id=16713&format=png&color=000000" />
              </div>
              <span>+91 94038 91941</span>
            </a>

          </div>
        </div>

        {/* Form Start */}
        {Success ? (
          <>
            <section className="flex items-center justify-center" id="thankyou">
              <div className="p-2 rounded-lg max-w-4xl text-center">
                <div className="flex justify-center mb-6">
                  <div className="w-16 h-16 flex items-center justify-center border-2 border-green-600 rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-green-600" fill="none"
                      viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                </div>
                <h1 className="text-3xl font-semibold mb-4">Thank you for your inquiry!</h1>

                <p className="text-gray-700">
                  As we process your request, start exploring other exciting travel options and ideas in our blog
                  section.
                  Happy exploring!
                </p>
              </div>
            </section>
          </>
        ) : (
          <>

            <form className="space-y-4" onSubmit={submit}>

              {/* Radio Options */}
              <div className="flex gap-6 justify-start mb-6 px-1">
                {[{ name: 'Flight', id: '1' }, { name: 'Hotel', id: '2' }, { name: 'Package', id: '3' }].map((option) => (
                  <label key={option.id} className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer">
                    <input
                      type="radio"
                      name="PlanType"
                      value={option.id}
                      checked={form.PlanType === option.id}
                      onChange={handleChange}
                      className="w-4 h-4 accent-blue-700"
                    />
                    {option.name}
                  </label>
                ))}
              </div>

              {/* Name Row */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <select name='title' value={form.title} onChange={handleChange} className="col-span-1 border border-gray-300 rounded-md p-2.5 text-sm text-gray-500 focus:ring-1 focus:ring-blue-600 outline-none bg-white">
                  <option value="Mr">Mr.</option>
                  <option value="Ms">Ms.</option>
                  <option value="Mrs">Mrs.</option>
                </select>
                <input type="text" name='fname' value={form.fname} onChange={handleChange} placeholder="First Name *" className=" border border-gray-300 rounded-md p-2.5 text-sm focus:ring-1 focus:ring-blue-600 outline-none w-full" />
                <input type="text" name='lname' value={form.lname} onChange={handleChange} placeholder="Last Name *" className=" border border-gray-300 rounded-md p-2.5 text-sm focus:ring-1 focus:ring-blue-600 outline-none w-full" />
              </div>

              {/* Mobile Input */}
              <div className="flex border border-gray-300 rounded-md overflow-hidden">
                <span className="bg-gray-50 px-3 py-2.5 text-sm text-gray-500 border-r border-gray-300">+91</span>
                <input type="tel" placeholder="Mobile *" name='mobile' value={form.mobile} onChange={handleChange} className="w-full p-2.5 text-sm focus:ring-1 focus:ring-blue-600 outline-none" />
              </div>

              {/* Standard Inputs */}
              <input type="email" placeholder="Email Address *" name='email' value={form.email} onChange={handleChange} className="w-full border border-gray-300 rounded-md p-2.5 text-sm focus:ring-1 focus:ring-blue-600 outline-none" />
              <CityAutosuggest onSelect={onSelect} placeholder={'Type destination...'} form={form} />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {/* <input
                  type="date"
                  placeholder="Departure Date"
                  name="TravelDate"
                  value={form.TravelDate}
                  min={new Date().toISOString().split("T")[0]}

                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-md p-2.5 text-sm focus:ring-1 focus:ring-blue-600 outline-none"
                /> */}
                <div className="relative w-full">
                  <input
                    type="date"
                    name="TravelDate"
                    value={form.TravelDate}
                    min={new Date().toISOString().split("T")[0]}
                    onChange={handleChange}
                    className={`w-full border border-gray-300 rounded-md p-2.5 text-sm focus:ring-1 focus:ring-blue-600 outline-none appearance-none bg-white
      ${!form.TravelDate ? "text-gray-400" : "text-gray-900"}`}
                  />
                  {!form.TravelDate && (
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-gray-400 pointer-events-none">
                      Departure Date *
                    </span>
                  )}
                </div>
                {/* <input type="date" placeholder="Travel Date" name='TravelDate' value={form.TravelDate} onChange={handleChange} className="w-full border border-gray-300 rounded-md p-2.5 text-sm focus:ring-1 focus:ring-blue-600 outline-none" /> */}
                <input type="number" placeholder="No. of Pax *" name='adult' value={form.adult} onChange={handleChange} className="w-full border border-gray-300 rounded-md p-2.5 text-sm focus:ring-1 focus:ring-blue-600 outline-none" />

                {/* <input type="text" placeholder="Destination" name='FromCity' value={form.FromCity} onChange={handleChange} className="w-full border border-gray-300 rounded-md p-2.5 text-sm focus:ring-1 focus:ring-blue-600 outline-none" /> */}
              </div>


              {/* Textarea */}
              <textarea
                placeholder="Remarks.... *"
                rows="4"
                name='remarks' value={form.remarks} onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-2.5 text-sm focus:ring-1 focus:ring-blue-600 outline-none resize-none"
              ></textarea>

              {/* Consent Checkbox */}
              <div className="flex items-start gap-2 px-1">
                <input type="checkbox" checked={form.consent} id="consent" className="mt-1 accent-blue-700" />
                <label htmlFor="consent" className="text-xs text-gray-600">
                  I request and authorize {getSiteName()} to contact me.
                  <a className='text-[#089bda] ' href={`https://${getdomainName()}/`}>Visit Website</a>
                </label>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#089bda] hover:bg-[#1dbafd] text-white font-bold py-3.5 rounded-lg transition-colors duration-200 mt-4 tracking-wide"
              >
                {loading ? 'Sending...' : 'Send Enquiry'}
              </button>
            </form>
          </>
        )}


      </div>
    </div>
  );
};

export default Enquiry;